import { Type } from '@angular/core';

import { BreadcrumbsComponent } from '@app/shared/breadcrumbs/breadcrumbs';
import { CsSelect } from '@app/shared/cs-select/cs-select';
import { CsToasterComponent } from '@app/shared/cs-toaster/cs-toaster.component';
import { ServiceBridge } from '@app/shared/service-bridge/service-bridge';

/**
 * Every component published as a `cs-v20-*` custom element eagerly, at bootstrap.
 *
 * Kept in its own file (not inline in main.prod.ts, which bootstraps on import) so tests
 * can assert that the tags consuming MFEs mount by name are still registered — dropping an
 * entry here removes the element from the bundle and the consumer renders nothing, with no
 * build error anywhere.
 *
 * Deliberately small: this bundle loads globally on every v4 page, so only components with
 * either broad cross-MFE usage (cs-select) or infra that must be available immediately
 * (service-bridge — must mount before other web components; toaster — global notifications
 * triggered from anywhere; breadcrumbs — used by both the v4 shell and consuming MFEs) belong
 * here. Everything else moved to `lazyElementList` (see lazy-element-list.ts) once it stopped
 * being a shared dependency of anything on this list — check for that before moving another
 * entry here, the same way cs-ag-grid was blocked by defects-and-recommendations-card.
 */
export const elementList: { class: Type<unknown>; tagName: string }[] = [
    { class: CsSelect, tagName: 'cs-v20-select' },
    { class: BreadcrumbsComponent, tagName: 'cs-v20-breadcrumbs' },
    { class: ServiceBridge, tagName: 'cs-v20-service-bridge' },
    { class: CsToasterComponent, tagName: 'cs-v20-toaster' },
];
